import {lazy} from "react";

export const SmsAdminLazy = lazy(() => import('./SmsAdmin'))